<div class="flex pb-2 w-full">
  <app-widget-wrapper
    size="small"
    [widgetComponent]="WidgetComponent.Empty"
    (widgetSelectedChange)="widgetSelectedChange($event)"
    [footerTitle]="'widgets.empty.header' | translate">
  </app-widget-wrapper>
  <app-widget-wrapper
    size="small"
    [widgetComponent]="WidgetComponent.UserRoles"
    (widgetSelectedChange)="widgetSelectedChange($event)"
    [footerTitle]="'widgets.userRoles.header' | translate">
    <app-widget-users></app-widget-users>
  </app-widget-wrapper>
</div>
